var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-subheader",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("back")
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
          _c("h2", [_vm._v("Scheme Details")]),
          _c("span", { staticStyle: { color: "transparent" } }, [_vm._v("X")])
        ],
        1
      ),
      this.cashbacks && this.cashbacks.length
        ? _c(
            "div",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "fit-content",
                    background: "#fffcf0",
                    margin: "auto",
                    padding: "1rem"
                  }
                },
                [
                  _c("div", [_vm._v("₹ " + _vm._s(_vm.sum) + "/1500")]),
                  _c(
                    "div",
                    [
                      _c("span", { staticStyle: { "margin-right": ".5rem" } }, [
                        _vm._v(_vm._s(_vm.upiId))
                      ]),
                      _c("v-dialog", {
                        attrs: {
                          transition: "dialog-bottom-transition",
                          "max-width": "600"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticStyle: {
                                            background: "#80808087",
                                            border: "none"
                                          },
                                          attrs: {
                                            icon: "",
                                            "x-small": "",
                                            outlined: "",
                                            raised: "",
                                            rounded: ""
                                          }
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "white"
                                          }
                                        },
                                        [_vm._v("mdi-pencil")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "default",
                              fn: function(dialog) {
                                return [
                                  _c(
                                    "v-card",
                                    { staticStyle: { padding: "1rem" } },
                                    [
                                      _c(
                                        "h1",
                                        {
                                          staticStyle: { "text-align": "left" }
                                        },
                                        [_vm._v("Enter your UPI ID")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "left",
                                            "font-weight": "bold",
                                            margin: "1rem 0"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "in which you want to receive "
                                          ),
                                          _c("br"),
                                          _vm._v(" monthly bonus")
                                        ]
                                      ),
                                      _c("v-text-field", {
                                        staticClass: "pt-0",
                                        staticStyle: { margin: "1rem 0" },
                                        attrs: {
                                          placeholder: "sharma@okicici",
                                          outlined: "",
                                          dense: "",
                                          type: "text"
                                        },
                                        model: {
                                          value: _vm.upiId,
                                          callback: function($$v) {
                                            _vm.upiId = $$v
                                          },
                                          expression: "upiId"
                                        }
                                      }),
                                      _c(
                                        "v-card-actions",
                                        { staticClass: "justify-end" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { text: "" },
                                              on: {
                                                click: function($event) {
                                                  dialog.value = false
                                                }
                                              }
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { text: "" },
                                              on: {
                                                click: function($event) {
                                                  _vm.saveUPI()
                                                  dialog.value = false
                                                }
                                              }
                                            },
                                            [_vm._v("Ok")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1857023729
                        )
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "v-list",
                _vm._l(_vm.cashbacks, function(cb, index) {
                  return _c(
                    "div",
                    { key: "cb-" + index, staticClass: "cashback" },
                    [
                      _c("h3", [_vm._v("Cashback " + _vm._s(index + 1))]),
                      _c("div", { staticClass: "status" }, [
                        _vm._v(_vm._s(cb.status))
                      ]),
                      _c("h1", { staticStyle: { color: "#48bb78" } }, [
                        _vm._v("₹ " + _vm._s(cb.amount))
                      ]),
                      _c("h4", [_vm._v("Date")]),
                      _c("div", [_vm._v(_vm._s(cb.date))]),
                      _c("hr", {
                        staticStyle: {
                          margin: ".5rem 0",
                          "border-color": "#d4d4d41c"
                        }
                      }),
                      _c("h4", [_vm._v("Transferred to UPI ID")]),
                      _c("div", [_vm._v(_vm._s(cb.upi))])
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        : _vm._e(),
      !(this.cashbacks && this.cashbacks.length)
        ? _c(
            "div",
            { staticStyle: { "text-align": "center", margin: "2rem 0" } },
            [_vm._v(" Loading payments ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }